import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { ISearchGrammarPointsV1Response } from './search-grammar-points-v1-response';
import { searchGrammarPointsV1ResponseSchema } from './search-grammar-points-v1-response';

export async function searchGrammarPointsV1(
  query: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<ISearchGrammarPointsV1Response>> {
  return getRequest<ISearchGrammarPointsV1Response>({
    path: '/grammar/search/v1',
    schema: searchGrammarPointsV1ResponseSchema,
    options: { ...options, params: { ...options?.params, q: query } },
  });
}
